import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'bo-delete-user-confirm-dialog',
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule, DialogModule],
  templateUrl: './delete-user-confirm-dialog.component.html',
  styleUrl: './delete-user-confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteUserConfirmDialogComponent {
  @Input() visible = false;
  @Input() userName = '';
  @Input() confirmed = false;
  @Input() deleting = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirmedChange = new EventEmitter<boolean>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() deleteConfirmed = new EventEmitter<void>();

  onVisibleChange(visible: boolean) {
    if (!visible) {
      this.cancelled.emit();
    }
    this.visibleChange.emit(visible);
  }

  onConfirmedChange(value: boolean) {
    this.confirmedChange.emit(value);
  }

  onCancel() {
    this.cancelled.emit();
    this.visibleChange.emit(false);
  }

  onConfirm() {
    this.deleteConfirmed.emit();
  }
}
